import React, { useState, useRef } from "react";
import styles from "./TextWithTooltip.module.scss";

const TextWithTooltip = ({ text, tooltipStyle = {} }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const textRef = useRef(null);

  return (
    <div className={styles.textContainer}>
      <span
        ref={textRef}
        className={styles.truncatedText}
        onMouseEnter={() => {
          if (textRef.current.scrollWidth > textRef.current.clientWidth)
            setShowTooltip(true);
        }}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {text}
      </span>
      {showTooltip && (
        <div className={styles.tooltip} style={tooltipStyle}>
          {text}
        </div>
      )}
    </div>
  );
};

export default TextWithTooltip;
